import React, { useMemo } from "react";
import EChart from "./EChart";
import { ECHART_TOOLTIP, ECHART_TOOLBOX, ECHART_PALETTE } from "../../Utilities/echartsTheme";
import { formatNumber } from "../../Utilities/numbers";

const EChartsFunnel = ({ data, title = "" }) => {
  const option = useMemo(() => {
    const funnelData = (data || []).map((item, idx) => ({
      name: item.name,
      value: item.value,
      itemStyle: { color: ECHART_PALETTE[idx % ECHART_PALETTE.length] },
    }));

    return {
      tooltip: {
        ...ECHART_TOOLTIP,
        trigger: "item",
        formatter: (p) => `<div style="font-weight:600">${p.name}</div>Count: ${formatNumber(p.value)}`,
      },
      toolbox: ECHART_TOOLBOX,
      series: [
        {
          name: title,
          type: "funnel",
          left: "10%",
          right: "10%",
          top: "8%",
          bottom: "8%",
          width: "80%",
          minSize: "20%",
          maxSize: "100%",
          sort: "descending",
          gap: 2,
          label: {
            show: true,
            position: "inside",
            fontSize: 12,
            fontWeight: "bold",
            color: "#fff",
            formatter: (p) => `${p.name}\n${formatNumber(p.value)}`,
          },
          labelLine: { show: false },
          itemStyle: {
            borderColor: "#fff",
            borderWidth: 1,
          },
          emphasis: {
            label: { fontSize: 14 },
            itemStyle: { shadowBlur: 10, shadowColor: "rgba(0,0,0,0.2)" },
          },
          data: funnelData,
          animationDuration: 800,
        },
      ],
    };
  }, [data, title]);

  return <EChart option={option} />;
};

export default EChartsFunnel;
